function consoleLogEvent(ctx) {
    console.log(JSON.stringify(ctx.event, null, 2));
    return ctx;
}
export const DevDestinationPlugin = {
    name: "Dev Destination Plugin",
    type: "destination",
    isLoaded: () => true,
    load: () => Promise.resolve(),
    track: consoleLogEvent,
    identify: consoleLogEvent,
    page: consoleLogEvent,
    alias: consoleLogEvent,
    group: consoleLogEvent,
    screen: consoleLogEvent,
};
//# sourceMappingURL=devDestination.js.map